import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PrimeReactProvider } from "primereact/api";
import { locale, addLocale } from 'primereact/api';
import store from './app/store';
import App from './App';
import "primereact/resources/themes/lara-light-indigo/theme.css";        
import 'primeicons/primeicons.css';
// import 'bootstrap/dist/css/bootstrap.css';
import '@fontsource/roboto';
import './styles/style.css';
import './styles/primeicons.css';

// Add French locale for PrimeReact
addLocale('fr', {
  firstDayOfWeek: 1,
  dayNames: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
  dayNamesShort: ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'],
  dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
  monthNames: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
  monthNamesShort: ['jan', 'fév', 'mar', 'avr', 'mai', 'jun', 'jul', 'aoû', 'sep', 'oct', 'nov', 'déc'],
  today: 'Aujourd\'hui',
  clear: 'Effacer'
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PrimeReactProvider value={{ unstyled: false }}>
      <App />
      </PrimeReactProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)
